export default __webpack_public_path__ + "static/media/thewraps.f6d555be.jpg";